const ROOT_LABELS: Record<string, string> = {
    patient: 'Пациент',
    author: 'Автор документа (врач)',
    legal_authenticator: 'Утверждающий (руководитель)',
    custodian: 'Организация-владелец',
    provider_organization: 'Организация',
}

const SUFFIX_LABELS: [string, string][] = [
    ['.snils', 'СНИЛС'],
    ['.position.code', 'код должности'],
    ['.position.display_name', 'название должности'],
    ['.address.state.code', 'код региона'],
    ['.address.state.display_name', 'название региона'],
    ['.address.postal_code', 'почтовый индекс'],
    ['.address.fias.aoguid', 'код улицы (ФИАС)'],
    ['.address.fias.houseguid', 'код дома (ФИАС)'],
    ['.address.city', 'город'],
    ['.address.street', 'улица'],
    ['.address.house', 'дом'],
    ['.address.flat', 'квартира'],
    ['.fio.family_name', 'фамилия'],
    ['.fio.given_name', 'имя'],
    ['.fio.patronymic_name', 'отчество'],
    ['.birth_date', 'дата рождения'],
    ['.gender', 'пол'],
    ['.passport.series', 'серия паспорта'],
    ['.passport.number', 'номер паспорта'],
    ['.policy.series', 'серия полиса ОМС'],
    ['.policy.number', 'номер полиса ОМС'],
]

export const formatEgiszGapLabel = (path: string): string => {
    const segments = path.split('.')
    const root = ROOT_LABELS[segments[0]] ?? segments[0]

    const suffixMatch = SUFFIX_LABELS.find(([suffix]) => path.endsWith(suffix))
    const detail = suffixMatch ? suffixMatch[1] : segments.slice(1).join(' → ')

    return detail ? `${root}: ${detail}` : root
}